var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.10835 12.3084C1.93085 13.4701 2.72335 14.2759 3.69335 14.6776C7.41251 16.2192 12.5875 16.2192 16.3067 14.6776C17.2767 14.2759 18.0692 13.4692 17.8917 12.3084C17.7833 11.5942 17.2442 11.0001 16.845 10.4192C16.3225 9.64925 16.2708 8.81008 16.27 7.91675C16.2708 4.46508 13.4642 1.66675 10 1.66675C6.53585 1.66675 3.72918 4.46508 3.72918 7.91675C3.72918 8.81008 3.67751 9.65008 3.15418 10.4192C2.75585 11.0001 2.21751 11.5942 2.10835 12.3084Z",
    stroke: "black",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 15.8335C7.04835 17.271 8.39669 18.3335 10 18.3335C11.6042 18.3335 12.9509 17.271 13.3334 15.8335",
    stroke: "black",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationicon);
export default __webpack_public_path__ + "static/media/notificationicon.2d045f576a44b1bbe4be12df1b0b3642.svg";
export { ForwardRef as ReactComponent };